var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"liste-competences--flex"},_vm._l((_vm.competences),function(competence,index){return _c('choix-competence',{key:index,attrs:{"callback":_vm.callback,"competence":competence}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }